import i18n from "../i18n";

// Working TDEE adjust— bridges the Summary tab's client-side
// fetch (no page reload, see SummaryHero.js's handleSaveOverride/
// handleResetOverride) to msb-api's nutrition-tdee-override route. Same
// reasoning as nutrition-table-templates.js: Nutrition Progress keeps a lot
// of state outside the URL (active tab, filters), so a reload would wipe it
// just to save a TDEE adjustment.
//
// Athlete-scoped (unlike nutrition-table-templates.js, which is coach-scoped
// and needs no proxyAthlete) — the frontend fetch includes
// ?proxyAthlete=<athleteId> on the URL, forwarded straight through to the
// msb-api call, same as client-goals.js's own action routes.

const parseJsonBody = (req) => {
  const { body } = req;
  if (typeof body !== "string") return body || {};
  try {
    return JSON.parse(body);
  } catch {
    return null;
  }
};

const failedMessage = (key, fallback) =>
  i18n.t(`athlete-portal:nutritionPage.progress.hero.adjustModal.errors.${key}`, fallback);

const NutritionTdeeOverride = (app) => {
  app
    .post("/nutrition-tdee-override", async ({ req, res, api }) => {
      res.headers = res.headers || {};
      res.headers["Content-Type"] = "application/json; charset=utf-8";

      const { proxyAthlete } = req.query;
      const body = parseJsonBody(req);
      if (body === null) {
        res.status = 400;
        res.body = JSON.stringify({ error: failedMessage("invalidBody", "Invalid request") });
        return;
      }

      const fallbackMessage = failedMessage("saveFailed", "Failed to save TDEE override");

      try {
        const response = await api(`nutrition-tdee-override?proxyAthlete=${proxyAthlete}`, {
          method: "POST",
          body: JSON.stringify({
            mode: body.mode,
            underLogPct: body.underLogPct,
            manualValue: body.manualValue,
          }),
          headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) {
          const text = await response.text();
          let errorPayload = { error: fallbackMessage };
          try {
            errorPayload = JSON.parse(text);
          } catch {
            if (text) errorPayload.error = text;
          }
          res.status = response.status;
          res.body = JSON.stringify(errorPayload);
          return;
        }

        const saved = await response.json().catch(() => ({}));
        res.status = response.status;
        res.body = JSON.stringify(saved);
      } catch (e) {
        res.status = 500;
        res.body = JSON.stringify({ error: e.message || fallbackMessage });
      }
    })

    .post("/nutrition-tdee-override/reset", async ({ req, res, api }) => {
      res.headers = res.headers || {};
      res.headers["Content-Type"] = "application/json; charset=utf-8";

      const { proxyAthlete } = req.query;
      const fallbackMessage = failedMessage("resetFailed", "Failed to reset TDEE override");

      try {
        const response = await api(`nutrition-tdee-override?proxyAthlete=${proxyAthlete}`, {
          method: "DELETE",
        });

        if (!response.ok) {
          const text = await response.text();
          let errorPayload = { error: fallbackMessage };
          try {
            errorPayload = JSON.parse(text);
          } catch {
            if (text) errorPayload.error = text;
          }
          res.status = response.status;
          res.body = JSON.stringify(errorPayload);
          return;
        }

        const result = await response.json().catch(() => ({}));
        res.status = response.status;
        res.body = JSON.stringify(result);
      } catch (e) {
        res.status = 500;
        res.body = JSON.stringify({ error: e.message || fallbackMessage });
      }
    });
};

export default NutritionTdeeOverride;
